module.exports = __webpack_public_path__ + "static/img/apple-touch-icon-144x144.d911b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-touch-icon-144x144.png
// module id = 413
// module chunks = 1